<template>
  <p>
    <player-link :playerId="playerId" label="игрок"/>
    (<router-link :to="{name: 'player_derbies', params: {playerId: playerId}}">скачки</router-link>)
  </p>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'DerbyPlayerInfo',

  components: {
    PlayerLink,
  },

  props: {
    derbyPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    playerId() {
      return this.derbyPlayerId.playerId;
    },
  },
};
</script>
